var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternshipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8819 0.1875L0 9.39583L6.13889 12.7415V21.9499L16.8819 27.8125L27.625 21.9499V12.7415L30.6944 11.0687V21.6736H33.7639V9.39583L16.8819 0.1875ZM27.3487 9.39583L16.8819 15.105L6.41514 9.39583L16.8819 3.68667L27.3487 9.39583ZM24.5556 20.1235L16.8819 24.3133L9.20833 20.1235V14.4144L16.8819 18.6042L24.5556 14.4144V20.1235Z",
    fill: "#D9A21B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipIcon);
export default __webpack_public_path__ + "static/media/internship_icon.4d207c021b7bc11f796534b2a4f47a48.svg";
export { ForwardRef as ReactComponent };